<form nz-form [formGroup]="form" nzLayout="vertical" (ngSubmit)="submit()">
  <!-- Package header -->
  <div class="p-3 bg-gray-50 rounded mb-4">
    <div class="font-medium">
      {{ purchase.displayName || purchase.package?.name }}
    </div>
    <div class="text-sm text-gray-500">
      {{ 'servicePackages.form.price' | translate }}:
      {{ purchase.purchasePrice | number : '1.2-2' }} ₾
      <span class="mx-1">·</span>
      {{ 'servicePackages.refund.used' | translate }}:
      {{ purchase.usedServicesCount }}/{{ purchase.totalServicesCount }}
    </div>
  </div>

  <!-- Return type: full price vs. remaining value -->
  <nz-form-item>
    <nz-form-label>{{
      'servicePackages.refund.typeLabel' | translate
    }}</nz-form-label>
    <nz-form-control>
      <nz-radio-group formControlName="refundType">
        <label nz-radio nzValue="FULL">
          {{ 'servicePackages.refund.type.full' | translate }}
        </label>
        <label nz-radio nzValue="REMAINING">
          {{ 'servicePackages.refund.type.remaining' | translate }}
        </label>
      </nz-radio-group>
    </nz-form-control>
  </nz-form-item>

  <!-- Refund method: balance / none / cashbox -->
  <nz-form-item>
    <nz-form-label>{{
      'servicePackages.refund.methodLabel' | translate
    }}</nz-form-label>
    <nz-form-control>
      <nz-radio-group formControlName="refundMethod">
        <label nz-radio nzValue="BALANCE">
          {{ 'servicePackages.refund.method.balance' | translate }}
        </label>
        <label nz-radio nzValue="NONE">
          {{ 'servicePackages.refund.method.none' | translate }}
        </label>
        <label nz-radio nzValue="CASHBOX">
          {{ 'servicePackages.refund.method.cashbox' | translate }}
        </label>
      </nz-radio-group>
    </nz-form-control>
  </nz-form-item>

  <!-- Which till day the money leaves. Shown only when the sale was on an
       earlier day — sold today, both options are the same till. -->
  @if (showSettlementChoice) {
  <nz-form-item>
    <nz-form-label>{{
      'servicePackages.refund.settlementLabel' | translate
    }}</nz-form-label>
    <nz-form-control>
      <nz-radio-group formControlName="settlementDay">
        <label nz-radio nzValue="TODAY">
          {{ 'servicePackages.refund.settlement.today' | translate }}
          <span class="text-gray-500">
            — {{ today | date : 'dd/MM/yyyy' }}
          </span>
        </label>
        <label nz-radio nzValue="SALE_DATE">
          {{ 'servicePackages.refund.settlement.saleDate' | translate }}
          <span class="text-gray-500">
            — {{ saleDate | date : 'dd/MM/yyyy' }}
          </span>
        </label>
      </nz-radio-group>
      <div class="text-xs text-gray-500 mt-1">
        {{ 'servicePackages.refund.settlementHint' | translate }}
      </div>
    </nz-form-control>
  </nz-form-item>
  }

  <!-- Optional reason -->
  <nz-form-item>
    <nz-form-label>{{
      'servicePackages.refund.commentLabel' | translate
    }}</nz-form-label>
    <nz-form-control>
      <textarea
        nz-input
        formControlName="comment"
        rows="2"
        [placeholder]="'servicePackages.refund.commentPlaceholder' | translate"
        maxlength="500"
      ></textarea>
    </nz-form-control>
  </nz-form-item>

  <nz-divider class="my-3"></nz-divider>

  <!-- Computed amount (read-only, never typed) -->
  <nz-spin [nzSpinning]="loadingPreview()">
    @if (fullyUsed()) {
    <nz-alert
      nzType="error"
      nzShowIcon
      [nzMessage]="'servicePackages.refund.fullyUsed' | translate"
    ></nz-alert>
    } @else if (preview(); as p) {
    <div class="p-3 bg-gray-50 rounded">
      <div class="flex justify-between">
        <span class="text-gray-500">
          {{ 'servicePackages.refund.refundable' | translate }}
        </span>
        <span class="font-medium"
          >{{ p.refundableTotal | number : '1.2-2' }} ₾</span
        >
      </div>
      <div class="flex justify-between">
        <span class="text-gray-500">
          {{ 'servicePackages.refund.moneyBack' | translate }}
        </span>
        <span class="font-semibold text-green-600">
          {{ p.moneyRefund | number : '1.2-2' }} ₾
        </span>
      </div>
      @if (p.voidedDebt > 0) {
      <div class="flex justify-between">
        <span class="text-gray-500">
          {{ 'servicePackages.refund.voidedDebt' | translate }}
        </span>
        <span>{{ p.voidedDebt | number : '1.2-2' }} ₾</span>
      </div>
      }
    </div>
    }
  </nz-spin>

  <!-- Footer -->
  <div class="flex justify-end gap-2 mt-4">
    <button type="button" nz-button nzType="default" (click)="cancel()">
      {{ 'buttons.cancel' | translate }}
    </button>
    <button
      type="submit"
      nz-button
      nzType="primary"
      nzDanger
      [nzLoading]="submitting()"
      [disabled]="!canSubmit()"
    >
      {{ 'servicePackages.refund.confirm' | translate }}
    </button>
  </div>
</form>
